import React from "react";
import {useNavigate as useReactNavigate} from "react-router-dom";

/**
 * @returns {(function(*, *): void)|*}
 */
export function useNavigate() {
    const reactNavigate = useReactNavigate();
    return function navigate(url, options) {
        reactNavigate(url, options);
    };
}
